<template>
  <transition name="slide-fade">
    <div class="page page-support">
      <div class="container">

        <h1><span @click="onSupportClick">Support</span></h1>
        <widget-admin :show="show" @close="show = false"></widget-admin>
        <h3 class="support-subtitle">Frequently Asked Questions</h3>

        <div class="row">
          <div class="col-4 mb-3">
            <iframe width="560" height="315" src="https://www.youtube.com/embed/-WDwFRdnwVQ" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
          </div>
        </div>

        <div class="row">
          <div class="col-12">

            <div class="accordion-group" id="accordionGroup" aria-multiselectable="true">

              <div class="accordion" v-for="(item, index) in questions" :key="index" :class="{active: index === selectedQuestion}">

                <div class="accordion-header">
                  <div v-b-toggle="'accordion-' + index" class="accordion-btn">
                    <div class="row">
                      <h3 class="col-10">{{item.question}}</h3>
                      <div class="col-2 accordion-icon-container">
                        <div class="accordion-icon"></div>
                      </div>
                    </div>

                  </div>
                </div>

                <b-collapse :id="'accordion-'+index" div class="accordion-collapse">
                  <div class="accordion-body" v-html="item.answer"></div>
                </b-collapse>

              </div>

            </div>


          </div>
        </div>

        <h3 class="support-subtitle">Can’t find an answer? Contact us directly</h3>

        <div class="row">
          <div class="col-12">
            <div class="box box--shadow">
              <div class="contact-details">

                <div class="row">
                  <div class="col-3 col-md-2"><strong>Email</strong></div>
                  <div class="col-9"><a href="mailto:info@microba.com.au">info@microba.com</a></div>
                </div>

                <div class="row">
                  <div class="col-3 col-md-2"><strong>Phone</strong></div>
                  <div class="col-9"><a href="tel:1300974621">1300 974 621</a></div>
                </div>

                <div class="row">
                  <div class="col-3 col-md-2"><strong>Mail</strong></div>
                  <div class="col-9">
                    GPO Box 469<br>
                    Brisbane, QLD 4001
                  </div>
                </div>

                <!--<div class="row">-->
                  <!--<div class="col-3 col-md-2"><strong>Location</strong></div>-->
                  <!--<div class="col-9">-->
                    <!--488 Queen St<br>-->
                    <!--Brisbane, QLD, Australia 4000-->
                  <!--</div>-->
                <!--</div>-->
              <!---->
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </transition>
</template>

<script>
import json from '@/config/faq.json'
import WidgetAdmin from '@/components/widgets/WidgetAdmin'
import authService from '@/services/authService'

export default {
  name: 'Support',
  components: {
    WidgetAdmin
  },
  data: function () {
    return {
      selectedQuestion: null,
      show: false
    }
  },
  methods: {
    onFaqClick: function (index) {
      this.selectedQuestion = index
    },
    onSupportClick: function () {
      if (authService.isAdmin()) {
        this.show = true
      }
    }
  },
  computed: {
    questions: function () {
      return json
    }
  },
  mounted () {
  }
}
</script>

<style scoped lang="scss">

  $orange: #FF8708;
  $blue: #00193D;
  $light-grey: #F4F4F4;

  .accordion-group {
    border-radius: 4px;
    background-color: white;
    box-shadow: 0 2px 4px 0 rgba(0,0,0,0.1);
    padding-left:1.75rem;
    padding-right:1.75rem;
    padding-top:0.25rem;
    padding-top:0.25rem;

    .accordion-header {
      border-bottom:4px solid $light-grey;
    }

    .accordion-body {
      background-color:$light-grey;
      padding:2rem 20px 2rem 30px;
      border-radius: 0px 0px 4px 4px;
      color: $blue;
      font-family: Roboto;
      font-size: 1rem;
      font-weight: 300;
      line-height: 1.5rem;
      width:100%;
    }

    .accordion-btn {
      background:none;
      border-color:transparent !important;
      padding-left:0px;
      padding-right:0px;
      white-space: initial;
      text-align: left;
      width:100%;
      cursor:pointer;

      h3 {
        color: $orange;
        font-family: Athelas;
        font-size: 1.5rem;
        line-height: 2rem;
        font-weight:400;
        margin-bottom: 2rem;
        margin-top: 2rem;
        transition:0.2s ease-out;
      }

      .accordion-icon-container {
        position:relative;
        display:flex;
        justify-content:flex-end;
        align-items:center;
      }

      .accordion-icon {
        width:14px;
        height:14px;
        position:relative;

        &:before, &:after {
          content:"";
          height: 3px;
          position: absolute;
          background: $orange;
          backface-visibility: hidden;
          transform: rotate(0deg);
          transition: transform 0.5s, background-color 0.2s ease-out;
          width: 100%;
          left: 0%;
          top: calc(50% - ( 3px / 2) );
        }
      }

      &.collapsed {
        h3 {
          color:$blue;
        }

        .accordion-icon {
          &:before, &:after {
            background: $blue;
          }
          &:before {
            transform: rotate(180deg);
          }
          &:after {
            transform: rotate(270deg);
          }
        }
      }

      &:hover, &:active, &:focus {
        background: none !important;
        border-color:transparent !important;
        box-shadow:none !important;
      }

      &:hover {
        h3 {
          color: $orange;
        }

        .accordion-icon {
          &:before, &:after {
            background: $orange;
          }
        }
      }
    }

    .accordion {
      &:nth-last-child(1) {
        .accordion-header {
          border-color:transparent;
        }

        .accordion-collapse {
          &:after {
            content:"";
            width:100%;
            position:relative;
            height:20px;
            display:block;
            background:white;
          }
        }
      }
    }

    @media (min-width:768px) {
      .accordion-body {
        padding:30px 30px 30px 40px;
      }
      .accordion-btn {
        padding-left:20px;
        padding-right:20px;

        h3 {
          font-size: 1.5rem;
        }
      }

    }
  }

  .support-subtitle {
    color: $blue;
    font-family: Athelas;
    font-size: 1.5rem;
    line-height: 2rem;
    font-weight:400;
    margin-top:2.25rem;
    margin-bottom:1.25rem;
  }


  .contact-details > .row {
    font-size: 16px;
    border-bottom: 2px solid $light-grey !important;
    padding: 2rem 0;
    &:last-of-type {
      border-bottom-width: 0;
    }
  }

  .contact-details strong {
    color: $blue;
  }


</style>



// WEBPACK FOOTER //
// src/application/customer/Support.vue